/**
 * Deterministic weather timeline (architecture §6, SPEC-10): the state for a given
 * world time comes from a seeded table — every client computes the same thing
 * without any network traffic.
 */
import { WEATHER_PRESETS } from '@kota-nova/shared';
import { hash32 } from './prng.js';
/** The auto-weather rotation used by the prototype (16 slots per cycle). */
const AUTO_SEQ = [
    'clear',
    'clear',
    'cloudy',
    'rain',
    'clear',
    'cloudy',
    'heatwave',
    'storm',
    'clear',
    'fog',
    'cloudy',
    'rain',
    'clear',
    'snow',
    'clear',
    'cloudy',
];
/** One weather slot per 180 game minutes (3 game hours). */
export const WEATHER_SLOT_MINUTES = 180;
/**
 * Weather state at a given day + minute of day (SimPure.weatherAt).
 * Deterministic: same (worldSeed, day, minutes) on every client.
 */
export function weatherAt(worldSeed, day, minutes) {
    const slot = Math.floor((day * 1440 + minutes) / WEATHER_SLOT_MINUTES);
    const h = hash32(worldSeed, slot * 7 + 3);
    const index = h % AUTO_SEQ.length;
    return AUTO_SEQ[index];
}
/** Continuous parameters of a weather state (shared preset table). */
export function weatherPreset(state) {
    return WEATHER_PRESETS[state];
}
/** Deterministic day index and minute-of-day for an absolute world time (ms). */
export function weatherAtWorldTime(worldSeed, worldTimeMs) {
    const day = worldDayOf(worldTimeMs);
    const minutes = (((worldTimeMs / 60000) % 1440) + 1440) % 1440;
    return weatherAt(worldSeed, day, minutes);
}
function worldDayOf(worldTimeMs) {
    return Math.floor(worldTimeMs / (1440 * 60000));
}
